import { object, string } from "yup";

export const loginValidation = object().shape({
  email: string().trim().email()
    .required(),
  password: string()
    .min(6, "passwordMinRule")
    .max(64, "passwordMaxRule")
    .required(),
});
